import { createRouter, createWebHistory } from 'vue-router';
import HelloWorld from './components/HelloWorld.vue';
import ColorList from './components/ColorList.vue';
import MosaicManager from './components/MosaicManager.vue';
import MosaicConcepteur from './components/MosaicConcepteur.vue';
import PixelArtPlace from './components/PixelArtPlace.vue';
import PixelArtCard from './components/PixelArtCard.vue';
import RegisterForm from './components/RegisterForm.vue';
import Login from './components/LoginForm.vue'; // Assure-toi d'avoir un composant Login
import Logout from './components/AwaitLogout.vue';
import authService from './services/authService'; // Importe le service d'authentification
import ProfileManager from './components/ProfileManager.vue';
import PixelArtCardPublic from './components/PixelArtCardPublic.vue';
import PWAInstall from './components/PWAInstall.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld
  },
  {
    path: '/couleur',
    name: 'ColorList',
    component: ColorList,
    meta: { requiresAuth: true } // Cette route nécessite une authentification
  },
  {
    path: '/profileManager',
    name: 'ProfileManager',
    component: ProfileManager,
    meta: { requiresAuth: true } // Cette route nécessite une authentification
  },
  {
    path: '/mosaic',
    name: 'MosaicManager',
    component: MosaicManager,
    meta: { requiresAuth: true } // Cette route nécessite une authentification
  },
  {
    path: '/register',
    name: 'RegisterForm',
    component: RegisterForm,
  },
    {
    path: '/carde/:id', // <-- Ajoute le paramètre dynamique :id
    name: 'PixelArtCard',
    component: PixelArtCard,
    meta: { requiresAuth: false }
  },
  {
    path: '/place',
    name: 'PixelArtPlace',
    component: PixelArtPlace,
    meta: { requiresAuth: false } // Cette route nécessite une authentification
  },
  {
    path: '/concepteur',
    name: 'MosaicConcepteur',
    component: MosaicConcepteur,
    meta: { requiresAuth: true } // Cette route nécessite une authentification
  },
  {
    path: '/place/carde/:id',
    name: 'PixelArtCardPublic',
    component: PixelArtCardPublic,
    meta: { requiresAuth: false } // Cette route nécessite une authentification
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout // ← Ne pas utiliser beforeEnter ici
  },
  {
    path: '/pwa',
    name: 'PWA',
    component: PWAInstall
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guard pour vérifier l'authentification
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Vérifie si la route nécessite une authentification
    if (!authService.getToken()) {
      // Si le token n'est pas présent, redirige vers la page de connexion
      next({ path: '/login' });
    } else {
      next();
    }
  } else {
    next();
  }
  if (from.path === '/concepteur' && from.query.mosaicId) {
    const mosaicId = from.query.mosaicId; // Récupère l'ID de la mosaïque
    const gridKey = `grid${mosaicId}`; // Construit la clé pour le localStorage
    const historyKey = `history${mosaicId}`; // Construit la clé pour le localStorage

    localStorage.removeItem(gridKey); // Supprime l'élément du localStorage
    localStorage.removeItem(historyKey); // Supprime l'élément du localStorage 

  }
});



export default router;